<div class="page-header">
    <div class="col-12">
        <h1>Productivity Summary <small>Summary of current hours, progress, and efficiency for jobs and phases</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row action-toolbar" style="margin-top: 15px">
        <div class="col-12">
            <form class="form-inline">
                <action-toolbar-count [grid]="grid"></action-toolbar-count>
                <grid-export [grid]="mainGrid" [name]="'Productivity Summary'"></grid-export>

                <div class="input-header-group">
                    <span class="input-header">Cost Type</span>
                    <wj-combo-box
                        name="selectedPhaseType"
                        [(ngModel)]="selectedCostType"
                        [itemsSource]="costTypeList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="true"
                        (ngModelChange)="getReportData()"
                        style="min-width: 150px"
                    >
                    </wj-combo-box>
                </div>

                <div class="input-header-group">
                    <span class="input-header">Job Status</span>
                    <wj-multi-select
                        name="jobActvityType"
                        (checkedItemsChanged)="updateProjectManagerList()"
                        [itemsSource]="activeList"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        style="min-width: 150px"
                    ></wj-multi-select>
                </div>

                <div class="input-header-group">
                    <span class="input-header">Filter Progress &lt; 100%</span>
                    <wj-combo-box
                        name="filterByProgressComplete"
                        [(ngModel)]="selectedFilterByProgressComplete"
                        [itemsSource]="filterByProgressCompleteList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        (ngModelChange)="getReportData()"
                        style="min-width: 150px"
                    >
                    </wj-combo-box>
                </div>

                <div class="input-header-group">
                    <span class="input-header">Assume Hard Closed 100%</span>
                    <wj-combo-box
                        name="assumeHardClosedComplete"
                        [(ngModel)]="selectedAssumeHardClosedComplete"
                        [itemsSource]="assumeHardClosedCompleteList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        (ngModelChange)="getReportData()"
                        style="min-width: 150px"
                    >
                    </wj-combo-box>
                </div>

                <div class="input-header-group">
                    <span class="input-header">FS Phases</span>
                    <wj-combo-box
                        name="fsPhaseFilter"
                        [(ngModel)]="selectedFsPhaseFilter"
                        [itemsSource]="fsPhaseFilterList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        (ngModelChange)="getReportData()"
                        style="min-width: 150px"
                    >
                    </wj-combo-box>
                </div>

                <div class="input-header-group">
                    <span class="input-header">Job Type</span>
                    <wj-multi-select
                        style="width: 300px"
                        [itemsSource]="jobTypeList"
                        [placeholder]="'Choose Job Types'"
                        [selectedValuePath]="'value'"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [showSelectAllCheckbox]="true"
                        [showFilterInput]="true"
                        [maxHeaderItems]="1"
                        (checkedItemsChanged)="updateJobTypeList()"
                    ></wj-multi-select>
                </div>

                <div class="input-header-group">
                    <span class="input-header">Project Manager</span>
                    <wj-multi-select
                        style="width: 300px"
                        [itemsSource]="pmList"
                        [placeholder]="'Choose Project Managers'"
                        [selectedValuePath]="'value'"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [showSelectAllCheckbox]="true"
                        [showFilterInput]="true"
                        [maxHeaderItems]="1"
                        (checkedItemsChanged)="updateJobList()"
                    ></wj-multi-select>
                </div>

                <div class="input-header-group">
                    <span class="input-header">Superintendent</span>
                    <wj-multi-select
                        style="width: 300px"
                        [itemsSource]="superintendentList"
                        [placeholder]="'Choose Superintendents'"
                        [selectedValuePath]="'value'"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [showSelectAllCheckbox]="true"
                        [showFilterInput]="true"
                        [maxHeaderItems]="1"
                        (checkedItemsChanged)="updateJobList()"
                    ></wj-multi-select>
                </div>

                <div class="input-header-group">
                    <span class="input-header">Jobs</span>
                    <wj-multi-select
                        style="width: 300px"
                        [itemsSource]="activeJobsList"
                        [placeholder]="'Choose Jobs'"
                        [selectedValuePath]="'value'"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [showSelectAllCheckbox]="true"
                        [showFilterInput]="true"
                        [maxHeaderItems]="1"
                        (checkedItemsChanged)="updatePhaseList()"
                    ></wj-multi-select>
                </div>

                <div class="input-header-group">
                    <span class="input-header">Activity Codes</span>
                    <wj-multi-select
                        style="width: 300px"
                        [itemsSource]="activityCodeList"
                        [placeholder]="'Choose Activity Codes'"
                        [selectedValuePath]="'value'"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [showSelectAllCheckbox]="true"
                        [showFilterInput]="true"
                        [maxHeaderItems]="1"
                        (checkedItemsChanged)="getReportData()"
                    ></wj-multi-select>
                </div>
            </form>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <grid-column-group [grid]="grid"></grid-column-group>
            <wj-flex-grid
                id="mainGrid"
                #mainGrid
                appAutoSize
                [padding]="73"
                (initialized)="grid.initialize(mainGrid)"
                [itemsSource]="grid.view"
                [itemFormatter]="gridItemFormatter"
                [keyActionTab]="'CycleEditable'"
                (formatItem)="onFormatItem($event)"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [minWidth]="250" [width]="'2*'"></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Phase'" [binding]="'phase'" [minWidth]="110" [width]="'1.5*'"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Actual Hours'"
                    [binding]="'totalHours'"
                    [width]="110"
                    [format]="'N2'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Est Hours'"
                    [binding]="'estHours'"
                    [width]="110"
                    [format]="'N2'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Variance'"
                    [binding]="'estVariance'"
                    [width]="110"
                    [format]="'N2'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Percent Used'"
                    [binding]="'percentUsed'"
                    [width]="110"
                    [format]="'P2'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Units Complete'"
                    [binding]="'unitsComplete'"
                    [width]="110"
                    [format]="'N2'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Actual Units'"
                    [binding]="'totalUnits'"
                    [width]="110"
                    [format]="'N2'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column [header]="'Units Modified By'" [binding]="'unitsModifiedBy'" [width]="140"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Units Actual Date'"
                    [binding]="'unitsActualDate'"
                    [width]="130"
                    [dataType]="'date'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'% Complete'"
                    [binding]="'progressCmplt'"
                    [width]="110"
                    [format]="'P2'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Calculated Budget Hrs'"
                    [binding]="'calculatedBudget'"
                    [width]="110"
                    [format]="'N2'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Calculated Budget Hrs-Actual'"
                    [binding]="'progressVariance'"
                    [width]="110"
                    [format]="'N2'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Calculated Projected Hours'"
                    [binding]="'calculatedProjectedHours'"
                    [width]="110"
                    [format]="'N2'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Projected Hours'"
                    [binding]="'projectedHours'"
                    [width]="110"
                    [format]="'N2'"
                    [aggregate]="'Sum'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Efficiency Rate'"
                    [binding]="'efficiencyRate'"
                    [width]="110"
                    [format]="'P2'"
                    [dataType]="'number'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="' '"
                    [binding]="''"
                    [width]="0"
                    [format]="'N'"
                    [aggregate]="'Sum'"
                    [dataType]="'number'"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'End Date'"
                    [binding]="'endDate'"
                    [width]="110"
                    [aggregate]="'None'"
                    [dataType]="'date'"
                ></wj-flex-grid-column>
            </wj-flex-grid>
            <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
        </div>
    </div>
</div>
